import { createFilter } from './BaseFilter';

export const createSearchFilter = ({ field, label, placeholder, searchableFields }) => {
    return createFilter({
        type: 'search',
        field,
        label,

        getInitialState: () => ({
            value: '',
            isActive: false
        }),

        applyFilter: (data, searchTerm) => {
            if (!searchTerm) return data;

            return data.filter(item => {
                return searchableFields.some(field => {
                    const value = item[field];
                    return value?.toString().toLowerCase().includes(searchTerm.toLowerCase());
                });
            });
        },

        renderFilter: ({ value, onChange }) => {
            return (
                <div style={{ minWidth: '300px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <label className="form-label mb-2">{label}</label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={placeholder}
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                        />
                        {value && (
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => onChange('')}
                            >
                                <i className="ri-close-line"></i>
                            </button>
                        )}
                    </div>
                </div>
            );
        },

        reset: () => ''
    });
};
